import { escape } from 'lodash-es';

export const getBlockDeletedCopy = (name: string) => `<p>${escape(name)}&nbsp;has hereby been removed</p>`;
